import { createFileRoute } from '@tanstack/react-router';

import { CompanyOverview } from '../features/manage/company-overview';

export const Route = createFileRoute('/manage/$companySlug/dashboard')({
  component: DashboardRoute,
});

function DashboardRoute() {
  const { companySlug } = Route.useParams();
  return <CompanyOverview companySlug={companySlug} />;
}
